import { computed } from 'vue';

export function useVModel(key, props, emit) {
	const event = `update:${key}`;
	return computed({
		get: () => props[key],
		set: (value) => emit(event, value),
	});
}
